/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';
import PatternModel from './PatternModel';
import HandleTwoModel from '../../../ShareModel/HandleModel/HandleTwoModel';


const FrenchDoorWalkInDoor = ({ width, height, trimWidth, doorColor, glassTexture, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])


    const doorWidth = (width - trimWidth * 2) / 2;
    const unitValue = doorWidth / 7
    const gutterDeviation = 0.15;
    const gutterSizeX = unitValue;
    const gutterSizeY = height / 13;
    const roundRadius = unitValue / 5;    
    const patternTopPosY = height / 2 - trimWidth - gutterSizeY;
    const patternBottomPosY = -height / 2 + gutterSizeY;

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [height, trimWidth, width])

    const doorModel = useMemo(() => {
        const deviation = 0.03;
        
        const model = new THREE.Shape();
        model.moveTo(-(doorWidth / 2 - deviation),  (height / 2 - deviation) - trimWidth);
        model.lineTo(-(doorWidth / 2 - deviation),  -(height / 2 - deviation));
        model.lineTo((doorWidth / 2 - deviation),  -(height / 2 - deviation));
        model.lineTo((doorWidth / 2 - deviation),  (height / 2 - deviation) - trimWidth);
        model.closePath();
        
        const hole = new THREE.Path();
        // The starting point location is top-mid
        hole.moveTo(0, patternTopPosY);
        hole.lineTo(doorWidth / 2 - gutterSizeX - roundRadius, patternTopPosY);
        hole.quadraticCurveTo(doorWidth / 2 - gutterSizeX, patternTopPosY, doorWidth / 2 - gutterSizeX, patternTopPosY - roundRadius);
        hole.lineTo(doorWidth / 2 - gutterSizeX, patternTopPosY - gutterSizeY * 3);
        hole.lineTo(doorWidth / 2 - gutterSizeX - gutterDeviation, patternTopPosY - gutterSizeY * 3 - gutterDeviation);
        hole.lineTo(doorWidth / 2 - gutterSizeX - gutterDeviation, patternBottomPosY + gutterSizeY * 3 + gutterDeviation);
        hole.lineTo(doorWidth / 2 - gutterSizeX, patternBottomPosY + gutterSizeY * 3);
        hole.lineTo(doorWidth / 2 - gutterSizeX, patternBottomPosY + roundRadius);
        hole.quadraticCurveTo(doorWidth / 2 - gutterSizeX, patternBottomPosY, doorWidth / 2 - gutterSizeX - roundRadius, patternBottomPosY);
        
        hole.lineTo(0, patternBottomPosY);
        
        hole.lineTo(-(doorWidth / 2 - gutterSizeX - roundRadius), patternBottomPosY);
        hole.quadraticCurveTo(-(doorWidth / 2 - gutterSizeX), patternBottomPosY, -(doorWidth / 2 - gutterSizeX), patternBottomPosY + roundRadius);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX), patternBottomPosY + roundRadius);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX), patternBottomPosY + gutterSizeY * 3);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX - gutterDeviation), patternBottomPosY + gutterSizeY * 3 + gutterDeviation);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX - gutterDeviation), patternTopPosY - gutterSizeY * 3 - gutterDeviation);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX), patternTopPosY - gutterSizeY * 3);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX), patternTopPosY - roundRadius);
        hole.quadraticCurveTo(-(doorWidth / 2 - gutterSizeX), patternTopPosY, -(doorWidth / 2 - gutterSizeX - roundRadius), patternTopPosY);
        hole.lineTo(-(doorWidth / 2 - gutterSizeX - roundRadius), patternTopPosY);

        hole.closePath();
        
        model.holes.push(hole);
        
        return model;
    
    }, [width, height, trimWidth])

    const insidePanModel = useMemo(() => {        
        const model = new THREE.Shape();
        model.moveTo(-(doorWidth / 2),  (height / 2) - trimWidth);
        model.lineTo(-(doorWidth / 2),  -(height / 2));
        model.lineTo((doorWidth / 2),  -(height / 2));
        model.lineTo((doorWidth / 2),  (height / 2) - trimWidth);
        model.closePath();

        return model;
    
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            {new Array(2).fill('').map((_, index) =>
                <mesh key={`inside-pan-model-${index}`} name='inside-pan' position={[Math.pow(-1, index) * doorWidth / 2, 0, 0.05]}>
                    <extrudeGeometry args={[insidePanModel, extrudeSettings(0.2)]} />
                    <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.6} />
                </mesh>
            )}
            {new Array(2).fill('').map((_, index) =>
                <mesh key={`door-model-${index}`} position={[Math.pow(-1, index) * doorWidth / 2, 0, 0.05]}>
                    <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                    <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} />
                </mesh>
            )}
            {new Array(2).fill('').map((_, indexI) =>
                new Array(2).fill('').map((_, indexJ) =>
                    <mesh key={`border-line-model-${indexI}-${indexJ}`} name='border-line-cylinder' position={[Math.pow(-1, indexJ) * 0.035, -0.05, 0.02 + 0.26 * indexI]}>
                        <cylinderGeometry args={[0.02, 0.02, height - trimWidth - 0.05, 10, 1]} />
                        <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.3} />
                    </mesh>
                )
            )}

            <PatternModel width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} glassTexture={glassTexture} />
            <HandleTwoModel handleModel={handleModel} />
        </>
    )
}

export default FrenchDoorWalkInDoor